import { Link } from "react-router-dom";

import { Button } from "@mui/material";

import UserMetaData from "../utils/UserMetaData";
import DoubtBody from "../doubt/DoubtBody";
import LikesIsDone from "../utils/LikesIsDone";
import useAuth from "../../hooks/useAuth";
import { DISPLAYING_FOR } from "../../config/AppEnums";

import "./css/doubt-on-feed.css";

const DoubtOnFeed = (props) => {
    const { auth } = useAuth();
    const {
        doubtId,
        askedById,
        askedBy,
        askedOn,
        updatedOn,
        title,
        desc,
        isSolved,
        likes,
        likedBy
    } = props;

    return (
        <div id={doubtId} className="doubt-on-feed">
            <UserMetaData
                displayingFor={DISPLAYING_FOR.DOUBT}
                userId={askedById}
                name={askedBy}
                askedOn={askedOn}
                updatedOn={updatedOn}
            />

            <DoubtBody title={title} desc={desc} />

            <div className="dof-bottom">
                <LikesIsDone
                    displayingFor={DISPLAYING_FOR.HOME}
                    displayingForId={doubtId}
                    likedBy={likedBy}
                    likes={likes}
                    isDone={isSolved}
                    isUserAuthenticated={askedById === auth.userId}
                />

                <Link className="dof-link" to={`/doubt/${doubtId}`}>
                    <Button variant="contained">
                        Answer
                    </Button>
                </Link>
            </div>
        </div>
    );
}

export default DoubtOnFeed;